import React from 'react'

const QuarantinePackages = () => {
  return (
    <div>QuarantinePackages</div>
  )
}

export default QuarantinePackages